module.exports = __webpack_public_path__ + "assets/img/5275-ao.svg";